var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bulk-inscan-overage-shipment"
  }, [(_vm.isoverageapprovalflag) ? _c('div', {
    staticClass: "access-denied"
  }, [_c('h2', [_vm._v("Access Denied")]), _vm._v(" "), _c('p', [_vm._v("This page has been disabled by a system flag. Update the configuration or reach out to support to enable access.")])]) : _vm._e(), _vm._v(" "), (!_vm.isoverageapprovalflag) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Bulk Process Overage Shipment")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitShipment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('shippingID')
    },
    attrs: {
      "type": "text",
      "rows": "10",
      "max-rows": "10",
      "placeholder": "Enter ShippingID, Use comma for multiple ShipmentID",
      "name": "shippingID",
      "id": "shippingID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shippingIDError),
      expression: "shippingIDError"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIDError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Inscan")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearID
    }
  }, [_vm._v("Clear")])])], 1), _vm._v(" "), (_vm.ProcessedShipmentIds.length > 0 || _vm.InvalidShipmentIds.length > 0) ? _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "id": "rightbox"
    }
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', [_c('th', [_vm._v("ProcessedShipmentIds")])]), _vm._v(" "), _c('tbody', [(_vm.ProcessedShipmentIds.length > 0) ? _vm._l((_vm.ProcessedShipmentIds), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingId) + " " + _vm._s(row.ReturnMessage))])])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('tr', [_c('th', [_vm._v("InvalidShipmentIds")])]), _vm._v(" "), _c('tbody', [(_vm.InvalidShipmentIds.length > 0) ? _vm._l((_vm.InvalidShipmentIds), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingId) + " " + _vm._s(row.ReturnMessage))])])
  }) : _vm._e()], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', {
    staticStyle: {
      "color": "#20a8d8",
      "font-size": "17px"
    }
  }, [_vm._v("Inscan only if you have shipment physically. Do not inscan for wrong overage.")])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.OverageBagList.length > 0) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("OverageLocation")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PreviousHubName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DestinationHubName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.OverageBagList), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.hubitem.text))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.reason),
        expression: "data.reason"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "reason"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(data, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBcapturedbyscanner"
      }
    }, [_vm._v("Wrong AWB captured by scanner")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBtypingerror"
      }
    }, [_vm._v("Wrong AWB typing error")])]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.reasonError))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.InscanBagOverage(data)
        }
      }
    }, [_vm._v("Save")])])], 1)])
  }), _vm._v(" "), ((_vm.OverageBagList && _vm.OverageBagList.length == 0) || _vm.OverageBagList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalRows > 10) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03da2914","hasScoped":true}!./src/views/components/BulkInscanOverageShipment/BulkInscanOverageShipment.html
// module id = 1653
// module chunks = 2